export default __webpack_public_path__ + "static/media/goldenbeerooftop2021.7adf5fdc.jpeg";